import ImageList from '@mui/material/ImageList';
import { TimeLineDataType } from '../../services/apiTypes';
import FeedPost from '../Feed/FeedPost';
import SnipzPost from '../Feed/SnipzPost';
import ProfilePost from '../Profile/ProfilePost';
import { Container } from './styles';

type MosaicProps = {
  columns: number,
  type: string;
  gap: number,
  variant?: "masonry" | "quilted" | "standard" | "woven",
  itemData: TimeLineDataType[]
};

export default function Mosaic({ columns, type, gap, variant, itemData }: MosaicProps) {
  return (
    <Container>
      <ImageList
        variant={variant}
        cols={columns}
        gap={gap}
      >
        {itemData && itemData.map((item) => (
          <div key={item.id}>
            {type === "snipz" && item.type === "snipz" &&
              <SnipzPost
                authorAvatarUrl={item.authorAvatarUrl}
                authorId={item.authorId}
                authorUsername={item.authorUsername}
                id={item.id}
                type={item.type}
                feedType={type}
                medias={item.medias}
                description={item.description}
                tags={item.tags}
                likes={item.likes}
                comments={item.comments}
                createdAt={item.createdAt}
                updatedAt={item.updatedAt}
                isLiked={item.isLiked}
              />}
            {type === "post" &&
              <FeedPost
                authorAvatarUrl={item.authorAvatarUrl}
                authorId={item.authorId}
                authorUsername={item.authorUsername}
                id={item.id}
                type={item.type}
                medias={item.medias}
                feedType={type}
                description={item.description}
                tags={item.tags}
                likes={item.likes}
                comments={item.comments}
                createdAt={item.createdAt}
                updatedAt={item.updatedAt}
                isLiked={item.isLiked}
              />}
            {type === "profile" &&
              <ProfilePost
                authorAvatarUrl={item.authorAvatarUrl}
                authorId={item.authorId}
                authorUsername={item.authorUsername}
                id={item.id}
                type={item.type}
                medias={item.medias}
                description={item.description}
                tags={item.tags}
                likes={item.likes}
                comments={item.comments}
                createdAt={item.createdAt}
                updatedAt={item.updatedAt}
                isLiked={item.isLiked}
              />}
          </div>
        ))}
      </ImageList>
    </Container>
  );
}